import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-management-login',
  templateUrl: './management-login.component.html',
  styleUrls: ['./management-login.component.css']
})
export class ManagementLoginComponent implements OnInit {

  constructor() { }

  setTheme(themeName: any) {
    localStorage.setItem('theme', themeName);
      document.documentElement.className = `${themeName} english-font`;
  }

  ngOnInit(): void {
    this.setTheme('theme-light');
  }

}
